import React from 'react';
import { Route } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Drawer from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from '@material-ui/core/Snackbar';
import InstallationsReport from './InstallationsReport';
import Notifications from './Notifications';
import NotificationList from './NotificationList';
import ApiProxy from './ApiProxy';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import Coupons from './Coupons';
import Coupon from './Coupon';
import CouponCreate from './CouponCreate';
import Highlights from './Highlights';
import Promotions from './Promotions';
import Promotion from './Promotion';
import PromotionCreate from './PromotionCreate';
import InstallmentConfig from './InstallmentConfig';
import FreeWeekends from './FreeWeekends';

export default class AuthorizedRoutes extends React.Component {

	apiProxy = new ApiProxy();

	constructor(props) {
		super(props);

		this.state = {
			loggedIn: false,
			openNavigationPanel: false,
			openSnackbar: false,
			snackbarMessage: ''
		};

		this.inflateInstallationsReportContainer = this.inflateInstallationsReportContainer.bind(this);
		this.inflateNotificationsContainer = this.inflateNotificationsContainer.bind(this);
		this.inflateNotificationsListContainer = this.inflateNotificationsListContainer.bind(this);
		this.inflateCuponsContainer = this.inflateCuponsContainer.bind(this);
		this.inflateCouponContainer = this.inflateCouponContainer.bind(this);
		this.inflateCouponCreateContainer = this.inflateCouponCreateContainer.bind(this);
		this.inflateHighlightsContainer = this.inflateHighlightsContainer.bind(this);
		this.fetchApi = this.fetchApi.bind(this);
		this.openNavigationPanel = this.openNavigationPanel.bind(this);
		this.navigateToInstallations = this.navigateToInstallations.bind(this);
		this.navigateToNotifications = this.navigateToNotifications.bind(this);
		this.navigateToNotificationList = this.navigateToNotificationList.bind(this);
		this.navigateToCupons = this.navigateToCupons.bind(this);
		this.navigateToCupon = this.navigateToCupon.bind(this);
		this.navigateToCouponCreate = this.navigateToCouponCreate.bind(this);
		this.navigateToHighlights = this.navigateToHighlights.bind(this);
		this.popCoupon = this.popCoupon.bind(this);
		this.showSnackbar = this.showSnackbar.bind(this);
		this.handleRequestCloseSnackbar = this.handleRequestCloseSnackbar.bind(this);
		this.closeNavigationPanel = this.closeNavigationPanel.bind(this);
    this.inflatePromotionsContainer = this.inflatePromotionsContainer.bind(this);
    this.inflatePromotionContainer = this.inflatePromotionContainer.bind(this);
    this.inflatePromotionCreateContainer = this.inflatePromotionCreateContainer.bind(this);
    this.navigateToPromotions = this.navigateToPromotions.bind(this);
    this.navigateToPromotion = this.navigateToPromotion.bind(this);
    this.navigateToPromotionCreate = this.navigateToPromotionCreate.bind(this);
	this.inflateInstallmentConfigContainer = this.inflateInstallmentConfigContainer.bind(this);
	this.navigateToInstallmentConfig = this.navigateToInstallmentConfig.bind(this);
	}

	componentDidMount() {
		let isLoggedIn = this.props.isLoggedIn();
		this.setState({ loggedIn: isLoggedIn });

		if (!isLoggedIn)
			this.props.redirectToLogin();

		this.apiProxy.setAuthToken(this.props.getToken());
		this.apiProxy.setRedirectToLogin(this.props.redirectToLogin);
		this.apiProxy.setDestroyToken(this.props.destroyToken);
	}

	fetchApi(method, url, data) {
		return this.apiProxy.fetchProtectedRoute(method, url, data);
	}

	inflateInstallationsReportContainer() {
		return (
			<InstallationsReport fetchApi={this.fetchApi} />
		);
	}

	inflateNotificationsContainer() {
		return <Notifications fetchApi={this.fetchApi} showSnackbar={this.showSnackbar} />
	}

	inflateNotificationsListContainer() {
		return <NotificationList fetchApi={this.fetchApi} showSnackbar={this.showSnackbar} />
	}

	inflateCuponsContainer() {
		return <Coupons
			fetchApi={this.fetchApi}
			showSnackbar={this.showSnackbar}
			navigateToCupon={this.navigateToCupon}
			navigateToCouponCreate={this.navigateToCouponCreate}
		/>
	}

	inflateCouponContainer(id) {
		return <Coupon
			fetchApi={this.fetchApi}
			showSnackbar={this.showSnackbar}
			popRoute={this.popCoupon}
			id={id}
		/>
	}

	inflateCouponCreateContainer() {
		return <CouponCreate
			fetchApi={this.fetchApi}
			popRoute={this.popCoupon}
		/>
	}

  inflatePromotionsContainer() {
    return (
      <Promotions
        fetchApi={this.fetchApi}
        showSnackbar={this.showSnackbar}
        navigateToPromotion={this.navigateToPromotion}
        navigateToPromotionCreate={this.navigateToPromotionCreate}
      />
    );
  }

  inflatePromotionContainer(props) {
    return (
      <Promotion
        fetchApi={this.fetchApi}
        showSnackbar={this.showSnackbar}
        popRoute={this.props.history.goBack}
        id={props}
      />
    );
  }

  inflatePromotionCreateContainer() {
    return (
      <PromotionCreate
        fetchApi={this.fetchApi}
        showSnackbar={this.showSnackbar}
        popRoute={this.props.history.goBack}
      />
    );
  }

	inflateInstallmentConfigContainer() {
		return <InstallmentConfig
			fetchApi={this.fetchApi}
			showSnackbar={this.showSnackbar}
		/>
	}

	inflateHighlightsContainer() {
		return <Highlights
			fetchApi={this.fetchApi}
			showSnackbar={this.showSnackbar}
		/>
	}

	closeNavigationPanel() {
		this.setState({
			openNavigationPanel: false
		});
	}

	openNavigationPanel() {
		this.setState({
			openNavigationPanel: true
		});
	}

	navigateToInstallations() {
		this.props.history.push({ pathname: '/' });
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToNotifications() {
		this.props.history.push({ pathname: '/notifications' });
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToNotificationList() {
		this.props.history.push({ pathname: '/notifications/list' });
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToCupons() {
		this.props.history.push({ pathname: '/coupons' });
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToHighlights() {
		this.props.history.push({ pathname: '/highlights' });
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToCupon(id) {
		this.props.history.push({ pathname: `/coupons/${id}` });
		this.setState({
			openNavigationPanel: false
		});
	}

	popCoupon() {
		this.props.history.goBack();
		this.setState({
			openNavigationPanel: false
		});
	}

	navigateToCouponCreate() {
		this.props.history.push({ pathname: '/coupon/create' });
		this.setState({
			openNavigationPanel: false
		});
	}

  navigateToPromotions() {
    this.props.history.push({ pathname: "/promotions" });
    this.setState({ openNavigationPanel: false });
  }

  navigateToPromotion(id) {
    this.props.history.push({ pathname: `/promotions/${id}` });
    this.setState({ openNavigationPanel: false });
  }

  navigateToPromotionCreate() {
    this.props.history.push({ pathname: "/promotion/create" });
    this.setState({ openNavigationPanel: false });
  }

	navigateToInstallmentConfig() {
		this.props.history.push({ pathname: '/installment-config' });
		this.setState({
			openNavigationPanel: false
		});
	}

	showSnackbar(message) {
		this.setState({
			openSnackbar: true,
			snackbarMessage: message
		});
	}

	handleRequestCloseSnackbar() {
		this.setState({
			openSnackbar: false
		});
	}

	render() {
		const { loggedIn, openNavigationPanel, openSnackbar, snackbarMessage } = this.state;

		const { history } = this.props;

		if (!loggedIn) {
			return null;
		}

		let currentSectionName;
		if (history.location.pathname.includes('/free-weekends')) {
			currentSectionName = 'FDS Grátis';
		} else if (history.location.pathname.includes('/notifications')) {
			currentSectionName = 'Notificações';
		} else if (history.location.pathname.includes('/coupons')) {
			if (history.location.pathname.split('/').last === 'coupons') {
				currentSectionName = `Cupon ${history.location.pathname.split('/').last}`;
			} else {
				currentSectionName = 'Cupons';
			}
		}
		else if (history.location.pathname.includes('/highlights')) {
			currentSectionName = 'Destaque';
		}
		else if (history.location.pathname.includes('/promotion')) {
    		currentSectionName = 'Promoções';
		}
		else if (history.location.pathname.includes('/installment-config')) {
			currentSectionName = 'Parcelamento';
		}
		else {
			currentSectionName = 'Instalações';
		}

		return (
			<div>
				<AppBar>
					<Toolbar>
						<IconButton edge="start" color="inherit" aria-label="menu" onClick={this.openNavigationPanel}>
							<MenuIcon />
						</IconButton>
						<Typography>{currentSectionName}</Typography>
					</Toolbar>
				</AppBar>
				<Drawer
					open={openNavigationPanel}
					onClose={this.closeNavigationPanel}
					variant="temporary"
				>
					<MenuItem onClick={this.navigateToInstallations}>Instalações</MenuItem>
					<MenuItem onClick={this.navigateToNotifications}>Enviar Notificação</MenuItem>
					<MenuItem onClick={this.navigateToNotificationList}>Lista de Notificações</MenuItem>
					<MenuItem onClick={this.navigateToCupons}>Cupons</MenuItem>
					<MenuItem onClick={this.navigateToHighlights}>Enviar Destaque</MenuItem>
					<MenuItem onClick={() => { this.props.history.push('/free-weekends'); this.closeNavigationPanel(); }}>FDS Grátis</MenuItem>
					<MenuItem onClick={this.navigateToPromotions}>Promoções</MenuItem>
					<MenuItem onClick={this.navigateToInstallmentConfig}>Parcelamento</MenuItem>
				</Drawer>
				<div style={{ padding: '3rem' }}>
					<Route path="/" component={this.inflateInstallationsReportContainer} exact />
					<Route path="/notifications" component={this.inflateNotificationsContainer} exact />
					<Route path="/notifications/list" component={this.inflateNotificationsListContainer} exact />
					<Route path="/coupons" component={this.inflateCuponsContainer} exact />
					<Route path="/coupons/:id" component={(id) => this.inflateCouponContainer(id)} exact />
					<Route path="/coupon/create" component={this.inflateCouponCreateContainer} exact />
					<Route path="/highlights" component={this.inflateHighlightsContainer} exact />
          			<Route path="/promotions" component={this.inflatePromotionsContainer} exact />
          			<Route path="/promotion/create" component={this.inflatePromotionCreateContainer} exact />
          			<Route path="/promotions/:id" component={this.inflatePromotionContainer} exact />
					<Route path="/free-weekends" exact render={props => <FreeWeekends {...props} fetchApi={this.fetchApi} />} />
                    <Route path="/free-weekends/new" exact render={props => <FreeWeekends {...props} fetchApi={this.fetchApi} />} />
                    <Route path="/free-weekends/:id" exact render={props => props.match.params.id === "new" ? null : <FreeWeekends {...props} fetchApi={this.fetchApi} />} />
					<Route path="/installment-config" component={this.inflateInstallmentConfigContainer} exact />
				</div>
				<Snackbar
					open={openSnackbar}
					message={snackbarMessage}
					onClose={this.handleRequestCloseSnackbar}
					autoHideDuration={3000}
					action={
						<IconButton
							color="inherit"
							onClick={this.handleRequestCloseSnackbar}
						>
							<CloseIcon />
						</IconButton>
					}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/AuthorizedRoutes.js